import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { DigestionTopicEditForm } from "./components/DigestionTopicEditForm";

export function EditDigestionTopicPage() {
  return (
    <LqsPage title="Edit Digestion Topic">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <DigestionTopicEditForm />
      </Container>
    </LqsPage>
  );
}
